import { GET_AUTOMATION_API } from '../../config/constant/apiConstant';
import { paginatedAutomationActions } from "../../redux/slicers/admin/paginatedAutomation";
import { createDeleteApiAction, createGetListAction, createUpdateApiAction } from '../apiGenerator';

export const getAutomationPageListApi = createGetListAction({
  endpoint: GET_AUTOMATION_API,
  actions: paginatedAutomationActions,
  setGlobalSidebarFilters: true,
});

export const deleteAutomationAPI = createDeleteApiAction({
  actions: paginatedAutomationActions,
  endpointUrl: GET_AUTOMATION_API,
  optimistic: false,
  successMessage: 'The File is deleted successfully',
})

export const automationUpdateApi = createUpdateApiAction({
  actions: paginatedAutomationActions,
  endpointUrl: GET_AUTOMATION_API,
})